import {
  GraphQLFieldConfig,
  GraphQLInt,
  GraphQLList,
  GraphQLNonNull,
  GraphQLObjectType,
  GraphQLString
} from 'graphql'
import { Context } from '../shared'
import {
  VulnerabilitySnapshotsArgs,
  vulnerabilitySnapshotsArgs
} from '../types/vulnerability-snapshots-args'
import { appendVulnerabilityFiltersToBody } from '../endpoint-helpers'

export interface VulnerabilityDiscoverySnapshotBreakdown {
  readonly timestamp: string
  readonly newlyIntroduced: number
  readonly duplicate: number
  readonly remediated: number
}

export const vulnerabilityDiscoverySnapshotBreakdownType =
  new GraphQLObjectType({
    name: 'VulnerabilityDiscoverySnapshotBreakdown',
    description: 'A single vulnerability discovery snapshot (data point)',
    fields: () => ({
      timestamp: {
        description: 'The timestamp (in milliseconds) of the snapshot',
        type: new GraphQLNonNull(GraphQLString)
      },
      newlyIntroduced: {
        description: 'Newly Introduced Discovery count',
        type: new GraphQLNonNull(GraphQLInt)
      },
      duplicate: {
        description: 'Duplicate Discovery count',
        type: new GraphQLNonNull(GraphQLInt)
      },
      remediated: {
        description: 'Remediated Discovery count',
        type: new GraphQLNonNull(GraphQLInt)
      }
    })
  })

export const vulnerabilityDiscoverySnapshots: GraphQLFieldConfig<
  any,
  Context,
  VulnerabilitySnapshotsArgs
> = {
  description: 'Get vulnerability discovery snapshots by Application',
  type: new GraphQLNonNull(
    new GraphQLList(vulnerabilityDiscoverySnapshotBreakdownType)
  ),
  args: vulnerabilitySnapshotsArgs,
  async resolve(
    _source,
    { organizationID, applicationID, filters, interval },
    context
  ): Promise<VulnerabilityDiscoverySnapshotBreakdown[]> {
    const mappedFilters = {
      ...appendVulnerabilityFiltersToBody(filters),
      interval
    }

    const { data } = await context.connector.post(
      `${organizationID}/traces/${applicationID}/snapshots/discovery`,
      mappedFilters
    )

    return normalizeSnapshots(data)
  }
}

function normalizeSnapshots(
  vulnTrend
): VulnerabilityDiscoverySnapshotBreakdown[] {
  return vulnTrend.map(({ timestamp, discovered, duplicated, remediated }) => {
    return {
      timestamp,
      newlyIntroduced: discovered,
      duplicate: duplicated,
      remediated
    }
  })
}
